import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const benefitsList = (params = '') => Http.get(`/account-benefits${serialize(params)}`)
export const benefitCreate = (params = '') => Http.post('/account-benefits', params)
export const benefitByID = (params = '') => Http.get(`/account-benefits${params}`)
export const benefitUpdate = (params = '') => Http.put(`/account-benefits/${params.id}`, params)
export const benefitDestroy = (params = '') => Http.delete(`/account-benefits/${params.id}`)
